import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from './Layout';  

import { Button } from 'react-bootstrap';

const AdminLeaves = () => {
  const navigate = useNavigate();

  return (
    <Layout heading="Leave Management">
  <div className="container mt-4">
    <div className="row justify-content-center">
      <div className="col-12 col-md-6 d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
        <Button
          variant="primary"
          className="w-100 w-md-auto px-4 py-2 fw-bold shadow"
          style={{ minWidth: "160px" }}
          onClick={() => navigate('/AdminHolidays')}
        >
          Public Holidays
        </Button>

        <Button
          variant="danger"
          className="w-100 w-md-auto px-4 py-2 fw-bold shadow"
          style={{ minWidth: "160px" }}
          onClick={() => navigate('/leaves')}
        >
          Leave Requests
        </Button>
        <Button
          variant="success"
          className="w-100 w-md-auto px-4 py-2 fw-bold shadow"
          style={{ minWidth: "160px" }}
          onClick={() => navigate('/wfh-requests')}
        >
          WFH Requests
        </Button>
      </div>
    </div>
  </div>
</Layout>


  );
};

export default AdminLeaves;
